<template>
	<div>
		<action-sidebar
			:title="`${subsidiaryName} - ${$route.meta.title}`"
			:value="true"
			@close-modal="closeModal"
		>
			<accounting-period-form :id="id" @on-close="closeModal" />
		</action-sidebar>
	</div>
</template>

<script>
import actionSidebar from '@/components/shared/action-sidebar';
import accountingPeriodForm from '@/components/accounting-periods/accounting-period-form';

function closeModal() {
	this.goTo(
		'accounting-periods',
		{
			params: {
				subsidiaryId: this.subsidiaryId,
				subsidiaryName: this.subsidiaryName,
			},
		},
	);
}

export default {
	name: 'page-accounting-period-edit',
	components: {
		actionSidebar,
		accountingPeriodForm,
	},
	methods: {
		closeModal,
	},
	props: {
		id: [Number, String],
		subsidiaryId: [Number, String],
		subsidiaryName: String,
	},
};
</script>



// WEBPACK FOOTER //
// src/pages/accounting-periods/page-accounting-period-edit.vue